export default __webpack_public_path__ + "static/media/push-talk.1a36de46.png";